var render, staticRenderFns
import script from "./Display.vue?vue&type=script&lang=ts&"
export * from "./Display.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c00baa76')) {
      api.createRecord('c00baa76', component.options)
    } else {
      api.reload('c00baa76', component.options)
    }
    
  }
}
component.options.__file = "src/components/data-entry/mixins/Display.vue"
export default component.exports